import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询加密类型列表
export const queryEncryptionType: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setEncryptionTypes', { ...state.encryptionType, loading: true });
    const res = await $http.get('/common/chooseoptions/EncryptionType');
    commit('setEncryptionTypes', { data: res });
  } catch (e) {
    commit('setEncryptionTypes', { data: [] });
  }
};

// 查询消息类型列表
export const queryMessageType: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setMessageTypes', { ...state.messageType, loading: true });
    const res = await $http.get('/common/chooseoptions/MessageType');
    commit('setMessageTypes', { data: res });
  } catch (e) {
    commit('setMessageTypes', { data: [] });
  }
};

// 查询邮箱列表
export const queryEmailList: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setEmailList', { ...state.emailList, loading: true });
    const res = await $http.get('message/email/option');
    commit('setEmailList', { data: res });
  } catch (e) {
    commit('setEmailList', { data: [] });
  }
};

// 查询sms列表
export const querySMSList: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setEmailList', { ...state.emailList, loading: true });
    const res = await $http.get('message/sms/option');
    commit('setEmailList', { data: res });
  } catch (e) {
    commit('setEmailList', { data: [] });
  }
};
